import {useDebugValue, useState} from 'react';

import {getNoUndefValuesObject} from '../../../utils/object';

function useSettings(defaultSettings, ...otherSettings) {
    const specifiedSettings = otherSettings.reduce((accumulatedSettings, currentSettings) => ({
        ...accumulatedSettings,
        ...getNoUndefValuesObject(currentSettings)
    }), {});

    const initialSettings = {
        ...defaultSettings,
        ...specifiedSettings
    };

    const [
        settings,
        setSettings
    ] = useState(initialSettings);

    function changeSettings(nextSettings) {
        setSettings((prevSettings) => ({
            ...prevSettings,
            ...nextSettings
        }));
    }

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useSettings};
